import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const AnnouncementTutorialModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=humuS61oxGk" />
);

export default AnnouncementTutorialModal;
